import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
import CxSearcher from '../../cx/CxSearcher';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreSettPsSubgroup } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';


const MxSettPsSubgroupForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  let r_form = React.useRef(null);
  let rf_txTypeGroup = React.useRef(null);

  const [storeSettPsSubgroup, setStoreSettPsSubgroup] = useSessionStorage('StoreSettPsSubgroup', StoreSettPsSubgroup);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus==='error') {
    } else {
      storeSettPsSubgroup.itPsSubgroup = lastSaveRv.theValue;
      Promise.all([setStoreSettPsSubgroup(storeSettPsSubgroup)]).then((result) => {
        navBack();
      });
    }
  }
  const formDelete = async (rv) => {
  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.pss')}: ${trans('field.subgroup')}`}
        xref={r_form}
        url="sett/ps_subgroup" 
        tooltip={trans('field.subgroup')}
        filterIdField='itPsSubgroup'
        filterIdValue={storeSettPsSubgroup.itPsSubgroup} 
        onFormLoad={formLoad} 
        onFormSave={formSave} 
        saveAndExit
        onFormDelete={formDelete} 
        >
        <CxHidden xref={useRef(null)} dbfield="t_ps_subgroup.itPsSubgroup" value={storeSettPsSubgroup.itPsSubgroup || ''} />

        <CxInput xref={useRef(null)} label={trans('field.subgroup')} dbfield="t_ps_subgroup.txTypePsSubgroup" required />

        <CxSearcher xref={rf_txTypeGroup} label={trans('field.group')}
          dbfield="t_ps_group.txTypePsGroup" dbfieldkey={`t_ps_subgroup.itPsGroup`}
          url="sett/ps_group"
          tooltip={trans('field.group')}
          col_id="itPsGroup"
          col_tx="txTypePsGroup"
          columns={[
            { id: "0", Header: "ID", accessor: "itPsGroup", show: false },
            { id: "1", Header: trans('field.group'), accessor: row => rf_txTypeGroup.current.getTable().highlightText(row["txTypePsGroup"]), width: '100%' },
          ]}
          required
        />
        
      </GxForm>

    </div>
  );

}

export default MxSettPsSubgroupForm;
